import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { NbThemeService } from "@nebular/theme";
import { takeWhile } from "rxjs/operators";
import { BarChart } from "../../@core/data/bar-chart";
import { LayoutService } from "../../@core/utils";

@Component({
  selector: "ngx-finance-chart",
  styleUrls: ["./charts-common.component.scss"],
  template: `
    <div
      echarts
      [options]="options"
      class="echart"
      (chartInit)="onChartInit($event)"
    ></div>
  `,
})
export class FinanceChartComponent
  implements AfterViewInit, OnDestroy, OnChanges
{
  @Input()
  financeChartData: BarChart;

  private alive = true;

  echartsIntance: any;
  options: any = {};

  constructor(
    private theme: NbThemeService,
    private layoutService: LayoutService
  ) {
    this.layoutService
      .onSafeChangeLayoutSize()
      .pipe(takeWhile(() => this.alive))
      .subscribe(() => this.resizeChart());
  }

  ngOnChanges(): void {
    if (this.echartsIntance) {
      this.updateBarChartOptions(this.financeChartData);
    }
  }

  ngAfterViewInit() {
    this.theme
      .getJsTheme()
      .pipe(takeWhile(() => this.alive))
      .subscribe((config) => {
        const eTheme: any = config.variables.profit;

        this.setOptions(eTheme);
      });
  }

  setOptions(eTheme) {
    this.options = {
      backgroundColor: eTheme.bg,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
          shadowStyle: {
            color: "rgba(0, 0, 0, 0.3)",
          },
        },
      },
      legend: {
        data: ["Thu", "Chi", "Số dư"],
        // textStyle: {
        //   color: ['','',''],
        // },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: this.financeChartData.chartLabel,
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            lineStyle: {
              color: eTheme.axisLineColor,
            },
          },
          axisLabel: {
            color: eTheme.axisTextColor,
            fontSize: eTheme.axisFontSize,
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          axisLine: {
            lineStyle: {
              color: eTheme.axisLineColor,
            },
          },
          splitLine: {
            lineStyle: {
              color: eTheme.splitLineColor,
            },
          },
          axisLabel: {
            color: eTheme.axisTextColor,
            fontSize: eTheme.axisFontSize,
          },
        },
      ],
      series: [
        {
          name: "Thu",
          type: "bar",
          barGap: 0,
          barWidth: "20%",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: eTheme.thirdLineGradFrom,
                },
                {
                  offset: 1,
                  color: eTheme.thirdLineGradTo,
                },
              ]),
            },
          },
          data: this.financeChartData.data[0],
        },
        {
          name: "Chi",
          type: "bar",
          barWidth: "20%",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#ffc107",
                },
                {
                  offset: 1,
                  color: "#ffaa00",
                },
              ]),
            },
          },
          data: this.financeChartData.data[1],
        },
        {
          name: "Số dư",
          type: "bar",
          barWidth: "20%",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: eTheme.secondLineGradFrom,
                },
                {
                  offset: 1,
                  color: eTheme.secondLineGradTo,
                },
              ]),
            },
          },
          data: this.financeChartData.data[2],
        },
      ],
    };
  }

  updateBarChartOptions(financeChartData: BarChart) {
    const options = this.options;
    const series = this.getNewSeries(options.series, financeChartData.data);

    this.echartsIntance.setOption({
      series: series,
      xAxis: {
        data: this.financeChartData.chartLabel,
      },
    });
  }

  getNewSeries(series, data: number[][]) {
    return series.map((line, index) => {
      return {
        ...line,
        data: data[index],
      };
    });
  }

  onChartInit(echarts) {
    this.echartsIntance = echarts;
  }

  resizeChart() {
    if (this.echartsIntance) {
      // Fix recalculation chart size
      // TODO: investigate more deeply
      setTimeout(() => {
        this.echartsIntance.resize();
      }, 0);
    }
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
